/* eslint-disable react-hooks/exhaustive-deps */
import { GenericType } from "@/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  updateData: GenericType;
  onAction: (prop: GenericType) => void;
  currentKey: string;
};

const formSchema = z.object({
  mapping: z.string().optional(),
  regions: z.any(),
  text: z.any(),
});

export const useClassificationTableForm = ({
  updateData,
  onAction,
  currentKey,
}: UseUserformType) => {
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      mapping: "",
      regions: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
      },
    },
  });

  useEffect(() => {
    if (updateData && Object.keys(updateData).length > 0) {
      schemaKeys.forEach((key) => {
        if (updateData[key]) {
          const value = updateData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [updateData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const updatedData = { ...updateData, ...values };
    onAction({
      type: "update",
      payload: { data: updatedData, key: currentKey },
    });
  }

  return { form, onSubmit };
};
